module.exports = __webpack_public_path__ + "img/monyback-gold.c3354334.svg";